import { DateTime, Settings } from 'luxon'
import i18next from 'i18next'
import AuthApiSingleton from '@/modules/Auth/AuthApi'

Settings.defaultLocale = DateTime.now().resolvedLocaleOptions().locale

i18next.on('languageChanged', (lng) => {
  Settings.defaultLocale = lng

  AuthApiSingleton.setLocale(lng)
})

export function formatNumber(n: number, padding = 2): string {
  return new Intl.NumberFormat(i18next.language, {
    minimumFractionDigits: padding,
    maximumFractionDigits: padding,
  }).format(n)
}

export function formatCurrency(value: number, currency: string): string {
  return new Intl.NumberFormat(i18next.language, {
    style: 'currency',
    currency,
  }).format(value).replace(/\s/g, '')
}
